import { BRANCHES, BRANCH_MAP, STATUSES, combinedLabel } from '../lib/branches.js';

/* ── Component ───────────────────────────────────────────────────────────── */

/**
 * BranchBadge — renders a circular branch insignia badge.
 *
 * Props:
 *   branchKey  {string}  – key from BRANCHES (e.g. 'army')
 *   statusKey  {string}  – optional key from STATUSES (e.g. 'veteran')
 *   size       {number}  – diameter in px (default 48)
 *   showLabel  {bool}    – show combined label below badge (default false)
 */
export default function BranchBadge({ branchKey, statusKey, size = 48, showLabel = false }) {
  if (!branchKey) return null;
  const b = BRANCH_MAP[branchKey];
  if (!b) return null;

  const label = statusKey ? combinedLabel(statusKey, branchKey) : b.label;

  return (
    <span className="branch-badge" title={label} style={{ '--badge-size': `${size}px` }}>
      <img
        className="branch-badge-img"
        src={b.emblem || `/brand/branches/${b.key}.png`}
        width={size}
        height={size}
        alt={label}
        loading="lazy"
      />
      {showLabel && (
        <span className="branch-badge-label">{label}</span>
      )}
    </span>
  );
}
/**
 * StatusSelect — dropdown for picking Active Duty / Veteran / Retired.
 * Always shown first, before BranchSelect.
 */
export function StatusSelect({ value, onChange, id = 'status-select', disabled = false }) {
  return (
    <select
      id={id}
      className="form-input"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    >
      <option value="">-- Select Status --</option>
      {STATUSES.map((s) => (
        <option key={s.key} value={s.key}>{s.label}</option>
      ))}
    </select>
  );
}

/**
 * BranchSelect — dropdown for picking branch (shown after status is chosen).
 */
export function BranchSelect({ value, onChange, id = 'branch-select', disabled = false }) {
  return (
    <select
      id={id}
      className="form-input branch-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    >
      <option value="">-- Select Branch of Service --</option>
      {BRANCHES.map((b) => (
        <option key={b.key} value={b.key}>{b.label}</option>
      ))}
    </select>
  );
}
